<template>
  <div>
    <div class="activity-content">
      <div class="right-content">
        <navigation :navName="nav"></navigation>
        <!--表格-->
        <div class="table-container">
          <el-button size="mini"
                     type="primary"
                     @click="goToEdit()">新增</el-button>
          <table-box :data="videoList"
                     ref="table"
                     :tableHeight="tableHeight"
                     id="rebateSetTable">
            <table-column prop="title"
                          label="标题"> </table-column>
            <table-column prop="updateTime"
                          label="更新时间"> </table-column>
            <table-column prop="editors"
                          label="编辑人"> </table-column>
            <table-column prop="sort"
                          label="优先级排序"
                          :width="'100px'">
              <template slot-scope="scope">
                <el-input type="number"
                          min="0"
                          size="mini"
                          v-model="scope.row.sort"
                          @change="_sort(scope.row)">
                </el-input>
              </template>
            </table-column>
            <table-column label="操作"
                          :width="'160px'"
                          alignType="left">
              <template slot-scope="scope">
                <span class="table-btn"
                      @click="handleEdit(scope.$index, scope.row)">编辑</span>

                <span class="table-btn"
                      v-if="!scope.row.release"
                      @click="_publish(scope.row,true)">发布</span>
                <span class="table-btn"
                      v-if="scope.row.release"
                      @click="_publish(scope.row,false)">取消发布</span>
                <span class="table-btn delete"
                      v-if="!scope.row.have_page"
                      @click="deleteItem(scope.$index, scope.row)">删除</span>
              </template>
            </table-column>
          </table-box>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { mapState } from 'vuex';
import api from '../../api/api';
import navigation from './navigation';

export default {
  data() {
    return {
      msg: {},
      nav: '123',
      tableHeight: 0,
    };
  },
  components: {
    navigation,
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight =
        document.documentElement.clientHeight - this.$refs.table.$el.offsetTop - 85;
    });
    const data = {
      wid: this.$store.state.websiteId,
      type: this.$store.state.navName,
    };
    this.$store.dispatch('getVideoList', data);
  },
  methods: {
    _sort(item) {
      axios.get(`${api.url}videoSort`, {
        params: {
          sort: item.sort,
          id: item._id,
        },
      }).then((response) => {
        const data = response.data;
        if (data.ret === 0) {
          this.$message({
            type: 'success',
            message: data.msg,
          });
          const msg = {
            type: this.$store.state.navName,
            wid: this.$store.state.websiteId,
          };
          this.$store.dispatch('getVideoList', msg);
        }
      });
    },
    goToEdit() {
      localStorage.setItem('videoId', '');
      this.$store.commit('getVideoId', '');
      this.$router.push({
        path: 'addVideo',
      });
    },
    _publish(item, type) {
      const myItem = item;
      axios.get(`${api.url}videoRelease`, {
        params: {
          id: item._id,
          type,
        },
      }).then((response) => {
        const data = response.data;
        if (data.ret === 0) {
          this.$message({
            type: 'success',
            message: data.msg,
          });
          myItem.release = type;
        }
      });
    },
    handleEdit(index, item) {
      localStorage.setItem('videoId', item._id);
      this.$store.commit('getVideoId', item._id);
      this.$router.push({
        path: 'addVideo',
      });
    },
    deleteItem(index, item) {
      const data = {
        id: item._id,
      };
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        axios.post(`${api.url}deleteVideo`, data).then((response) => {
          const videoData = response.data;
          if (videoData.ret === 0) {
            this.$store.state.videoList.splice(index, 1);
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
    },
  },
  computed: {
    ...mapState([
      'videoList',
    ]),
  },
};
</script>
<style lang="less">
.navigation {
  margin-bottom: 20px;
}
.btn {
  margin-bottom: 10px;
  display: flex;
  .el-input {
    width: 40%;
    margin-right: 20px;
  }
}
.pager {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/components/websiteConfig/videoTable.vue